import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
const listeners = new Set();
const notify = () => listeners.forEach((cb) => cb(cache));

export async function loadSiteTexts() {
  const { data } = await axios.get(`${API}/site-texts`);
  cache = data;
  notify();
  return data;
}

export function useSiteTexts() {
  const [texts, setTexts] = useState(cache);
  useEffect(() => {
    if (!cache) loadSiteTexts().catch(() => {});
    const cb = (t) => setTexts(t);
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);
  return texts || {};
}

export async function updateSiteText(token, key, value) {
  await axios.patch(
    `${API}/admin/site-texts/${key}`,
    { value },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (cache) {
    cache = { ...cache, [key]: value };
    notify();
  }
}
